export const initProfileEditAvailability = () => {
  const availabilityCalendar = document.getElementById("availability-calendar") as HTMLDivElement;

  if (!availabilityCalendar) {
    return;
  }

  const partOfDays: NodeListOf<HTMLTableCellElement> =
    availabilityCalendar.querySelectorAll("tr th:first-child");
  const days: NodeListOf<HTMLTableCellElement> =
    availabilityCalendar.querySelectorAll("tr:first-child th");

  partOfDays.forEach((item) => {
    item.addEventListener("click", () => {
      const row = item.closest("tr") as HTMLTableRowElement;

      const rowIndex = row.rowIndex + 1;
      const inputs: NodeListOf<HTMLInputElement> = availabilityCalendar.querySelectorAll(
        `tr:nth-child(${rowIndex}) input`,
      );

      let allAreChecked = true;

      inputs.forEach((input) => {
        if (!input.checked) {
          allAreChecked = false;
        }
      });

      // Uncheck all
      if (allAreChecked) {
        inputs.forEach((input) => {
          input.checked = false;
        });
        return;
      }

      // Check all
      inputs.forEach((input) => {
        input.checked = true;
      });
    });
  });

  days.forEach((item) => {
    item.addEventListener("click", () => {
      const cellIndex = item.cellIndex + 1;
      const inputs: NodeListOf<HTMLInputElement> = availabilityCalendar.querySelectorAll(
        `td:nth-child(${cellIndex}) input`,
      );

      let allAreChecked = true;

      inputs.forEach((input) => {
        if (!input.checked) {
          allAreChecked = false;
        }
      });

      // Uncheck all
      if (allAreChecked) {
        inputs.forEach((input) => {
          input.checked = false;
        });
        return;
      }

      // Check all
      inputs.forEach((input) => {
        input.checked = true;
      });
    });
  });
};
